import React from 'react';
import Home from '../components/Home';

const HomeContainer = () => {
  return <Home />;
};

export default HomeContainer;
